// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Input style */
.input-field-autocomplete input{
    background: transparent;
    width: 100%;
    font-family: var(--secondary-font);
    font-size: calc( var(--space) + 1px );
    font-style: normal;
    font-weight: normal;
    line-height: calc( var(--space) + var(--space-quarter) );
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    margin-left: var(--space);
}

/* label style */
.input-field-autocomplete label {
    background-color: var(--disabled-sb-bg-color);
    font-weight: var(--font-medium);
    font-family: var(--secondary-font);
    line-height: calc( var(--space) + var(--space-quarter) );
    font-size: calc( var(--space) + 1px );
    letter-spacing: 0.0025em;
    color: var(--basic-gray-color);
    text-transform: capitalize;
}

.input-field-autocomplete label.MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(0px, -22px);
}

.input-field-autocomplete div{
    border-radius: calc( var( --space-half ) + 1px );
    padding: 0px !important;
    background: var(--new-input-background-color);
}

.input-field-autocomplete .MuiOutlinedInput-input{
    padding: 0px;   
}

/* .input-field-autocomplete .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{
    border: var(--input-field-border);
} */

.input-field-autocomplete .MuiInputBase-input{
    height: calc(var(--space-x3));
}

.input-field-autocomplete .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input{
    padding: 0px;
}

.input-field-autocomplete .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child{
    padding: 0px;
}

.input-field-autocomplete.MuiFormControl-marginNormal{
    margin: 0px;
}

.input-field-autocomplete__list__icon{
    margin-right: calc( var(--space-half) /2);
}

.input-field-autocomplete__list__icon__img{
    width: var(--space-x2);
    height: var(--space-x2);
}

.MuiAutocomplete-option[data-focus="true"] {
    background-color: rgba(74, 234, 124, 0.5) !important;
}

/* .MuiAutocomplete-option {
    padding-top: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important; 
} */

.input-field-autocomplete__list.MuiListItem-gutters {
    padding-left: 8px;
    padding-right: 8px;
}

.MuiListItemText-root.input-field-autocomplete__listitem {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
}

.input-field-autocomplete__listitem .MuiTypography-body1 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc( var(--space) - 2px );
    line-height: calc(var(--space) + 4);
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--primary-dark-color) !important;
}

.input-field-autocomplete__listitem .MuiTypography-colorTextSecondary {    
    color: var(--basic-gray-color);
    font-size: var(--space-half-quarter);
    line-height: 16px;
}

.search_members_staff_edit_content .MuiListItem-container{
    list-style-type: none;
    width: 100%;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    background-color: var(--new-background-color);
    margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/input-field-autocomplete/InputFieldAutocompleteComponent.styles.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,uBAAuB;IACvB,WAAW;IACX,kCAAkC;IAClC,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;IACnB,wDAAwD;IACxD,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,6CAA6C;IAC7C,+BAA+B;IAC/B,kCAAkC;IAClC,wDAAwD;IACxD,qCAAqC;IACrC,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gDAAgD;IAChD,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA;IACI,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;;;;;GAKG;;AAEH;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,qCAAqC;IACrC,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,kDAAkD;IAClD,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;AACtB","sourcesContent":["/*Input style */\n.input-field-autocomplete input{\n    background: transparent;\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: calc( var(--space) + 1px );\n    font-style: normal;\n    font-weight: normal;\n    line-height: calc( var(--space) + var(--space-quarter) );\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    margin-left: var(--space);\n}\n\n/* label style */\n.input-field-autocomplete label {\n    background-color: var(--disabled-sb-bg-color);\n    font-weight: var(--font-medium);\n    font-family: var(--secondary-font);\n    line-height: calc( var(--space) + var(--space-quarter) );\n    font-size: calc( var(--space) + 1px );\n    letter-spacing: 0.0025em;\n    color: var(--basic-gray-color);\n    text-transform: capitalize;\n}\n\n.input-field-autocomplete label.MuiInputLabel-outlined.MuiInputLabel-shrink {\n    transform: translate(0px, -22px);\n}\n\n.input-field-autocomplete div{\n    border-radius: calc( var( --space-half ) + 1px );\n    padding: 0px !important;\n    background: var(--new-input-background-color);\n}\n\n.input-field-autocomplete .MuiOutlinedInput-input{\n    padding: 0px;   \n}\n\n/* .input-field-autocomplete .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{\n    border: var(--input-field-border);\n} */\n\n.input-field-autocomplete .MuiInputBase-input{\n    height: calc(var(--space-x3));\n}\n\n.input-field-autocomplete .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] .MuiAutocomplete-input{\n    padding: 0px;\n}\n\n.input-field-autocomplete .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] .MuiAutocomplete-input:first-child{\n    padding: 0px;\n}\n\n.input-field-autocomplete.MuiFormControl-marginNormal{\n    margin: 0px;\n}\n\n.input-field-autocomplete__list__icon{\n    margin-right: calc( var(--space-half) /2);\n}\n\n.input-field-autocomplete__list__icon__img{\n    width: var(--space-x2);\n    height: var(--space-x2);\n}\n\n.MuiAutocomplete-option[data-focus=\"true\"] {\n    background-color: rgba(74, 234, 124, 0.5) !important;\n}\n\n/* .MuiAutocomplete-option {\n    padding-top: 0px !important;\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n    padding-bottom: 0px !important; \n} */\n\n.input-field-autocomplete__list.MuiListItem-gutters {\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.MuiListItemText-root.input-field-autocomplete__listitem {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n}\n\n.input-field-autocomplete__listitem .MuiTypography-body1 {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc( var(--space) - 2px );\n    line-height: calc(var(--space) + 4);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--primary-dark-color) !important;\n}\n\n.input-field-autocomplete__listitem .MuiTypography-colorTextSecondary {    \n    color: var(--basic-gray-color);\n    font-size: var(--space-half-quarter);\n    line-height: 16px;\n}\n\n.search_members_staff_edit_content .MuiListItem-container{\n    list-style-type: none;\n    width: 100%;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    background-color: var(--new-background-color);\n    margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
